export const skipLogicES = {
  "begins with": "begins with",
  "contains": "contains",
  "does not begin with": "does not begin with",
  "does not contain": "does not contain",
  "does not end with": "does not end with",
  "does not equal": "does not equal",
  "ends with": "ends with",
  "equals": "equals",
  "in": "in",
  "is blank": "is blank",
  "is greater than": "is greater than",
  "is greater than or equal to": "is greater than or equal to",
  "is less than": "is less than",
  "is less than or equal to": "is less than or equal to",
  "is not blank": "is not blank",
  "is not in": "is not in",
  "is not like": "is not like",
  "like": "like",
};